import { render } from "./ModulesList.vue?vue&type=template&id=fb926ac6&scoped=true"
import script from "./ModulesList.vue?vue&type=script&lang=js"
export * from "./ModulesList.vue?vue&type=script&lang=js"

import "./ModulesList.vue?vue&type=style&index=0&id=fb926ac6&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb926ac6"]])

export default __exports__